import { withRouter } from 'react-router';
import ExtrasTrain from './ExtrasTrain';

export default withRouter(ExtrasTrain);
